import { CertificadoService } from '../services/certificado.service';
import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import DadosCertificadoModel from '../model/dados-certificado.model';
import { HttpUtilService } from '../services/http-util.service';

import { Subscription } from 'rxjs';

import { API_CNS_PORTAL } from '../app.api'
import Utils from '../utils/utils';
import DadosRegistroModel from '../model/dados-registro.model';

@Component({
  selector: 'app-topo',
  templateUrl: './topo.component.html',
  styleUrls: ['./topo.component.css']
})
export class TopoComponent implements OnInit, OnDestroy {

  @Input() public dadosCertificado: DadosCertificadoModel;
  @Input() public dadosRegistro: DadosRegistroModel;
  public razaoSocial: string;


  public certificados;
  public tipoInscricao;
  sub: Subscription;

  constructor(
    public httpUtilService: HttpUtilService,
    private certificadoService: CertificadoService) { }

  ngOnInit() {

  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }

  //Sobreescrito metodo getter...
  public get labelTipoInscricao() {
    return this.getLabelTipoInscricao(this.dadosCertificado.tpInscricao + '');
  }

  getLabelTipoInscricao(tipoInscricao: string): string {
    switch (tipoInscricao) {
      case "1":
        return 'CNPJ';
      case "2":
        return 'CEI';
      default:
        return 'CPF';
    }
  }

  private get inscricao(): string {
    let dados =  this.dadosCertificado.caepf ? this.dadosRegistro.nu_inscricao : this.dadosCertificado.inscricao;
   if(dados == null){
    dados = '';
   }

    return dados;
  }

  get inscricaoMascara() {
    return Utils.mascararInscricao(this.dadosCertificado.tpInscricao + '', this.inscricao);
  }

  get isInscricaoPF(): boolean {
    return this.dadosCertificado && 3 === +this.dadosCertificado.tpInscricao;
  }

  public redirecionaCnsPortal() {
    const token = sessionStorage.getItem('token');
    var url = API_CNS_PORTAL;
    var url = (!token) ? API_CNS_PORTAL : API_CNS_PORTAL + "?token=" + token;
    window.location.href = url;
  }

  get registroValido() {

    let tamanho = 15;

    if (this.dadosCertificado.razaoSocial.length < 15)
      tamanho = this.dadosCertificado.razaoSocial.length;
      
    const conteudo = this.dadosCertificado.razaoSocial.toString().substr(0, tamanho);
    return (conteudo === "0000000000000000") ? false : true;


  }
}
